<script setup>
/**
 * Import packages
 */
import { defineComponent } from 'vue';

/**
 * Component Name
 */
defineComponent({
  name: 'VTableBody',
});
</script>

<template>
  <div class="v-table-body">
    <slot />
  </div>
</template>
